
import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// パスワード変更
export const pwChange = (params) => {
    return http.requestPost(apiUrl.apiUrl_PwChange, params)
}
// メニュー状態管理検索
export const menuStateManagerGet = (userCd) => {
    return http.requestGet(apiUrl.apiurl_MenuStateManager + '?userId=' + userCd)
}
// お知らせ詳細検索
export const noticeDetailSearch = (userCd) => {
    return http.requestGet(apiUrl.apiUrl_NoticeDetailSearch + '?userCd=' + userCd)
}
// menu列表
export const login_check = (params) => {
    return http.requestPost(apiUrl.apiUrl_LoginCheck, params)
}





// WEBPACK FOOTER //
// ./src/module/api/i_0012.js